import { Box, Modal } from "@mui/material";
import React, { useState, useEffect } from "react";
import DeleteButton from "../Buttons/DeleteButton";
import EditButton from "../Buttons/EditButton";
import DateAndTimeChip from "../Chips/DateAndTimeChip";
import SmallClientChip from "../SmallClientChip";
import EditQuickNote from "./EditQuickNote";
import EditTherapyNote from "./EditTherapyNote";
import EditSupportStaffNote from "./EditSupportStaffNote";
import EditAftercareNote from "./EditAftercareNote";
import DeleteNote from "./DeleteNote";
import ViewNote from "./ViewNote";
import TypeNoteChip from "../Chips/TypeNoteChip";
import { useNavigate } from "react-router-dom";
import EditCBTNote from "./EditCBTNote";
import EditPsychoEdNote from "./EditPsychoEdNote";

function NotesContainerWithSubject(props) {
  const styleLive = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 700,
    height: 600,
    borderRadius: 5,
    backgroundColor: "white",
    boxShadow: 24,
  };

  const styleEdit = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    height: "80%",
    borderRadius: 5,
    backgroundColor: "white",
    boxShadow: 24,
  };

  const styleDeleteModal = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 300,
    height: 260,
    borderRadius: 2,
    bgcolor: "background.paper",
    boxShadow: 24,
  };

  const navigate = useNavigate();
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [shouldNavigate, setShouldNavigate] = useState(false);

  const openEditModal = () => setShowEditModal(true);
  const openDeleteModal = () => setShowDeleteModal(true);
  const closeEditModal = () => setShowEditModal(false);
  const closeDeleteModal = () => setShowDeleteModal(false);
  const closeViewModal = () => setShowViewModal(false);
  const handleNavigate = () => setShouldNavigate(true);

  useEffect(() => {
    if (shouldNavigate) {
      navigate(`/client/${props.clientId}`, { state: props });
    }
  }, [shouldNavigate, navigate, props]);

  return (
    <div className="notes-wrapper">
      <Modal open={showEditModal} onClose={closeEditModal}>
        <Box sx={styleEdit}>
          {props.noteType === "cbtNote" ? (
            <EditCBTNote
              noteId={props.noteId}
              sessionDateTime={props.sessionDateTime || props.effectiveDate}
              sessionNumber={props.sessionNumber}
              presentation={props.presentation}
              treatmentGoal={props.treatmentGoal}
              fileUrls={props.fileUrls}
              clientId={props.clientId}
              clientFirstName={props.clientFirstName}
              clientLastName={props.clientLastName}
              clientProfilePicture={props.clientProfilePicture}
              closemodal={closeEditModal}
            />
          ) : props.noteType === "therapyNote" ? (
            <EditTherapyNote
              note={props.noteContent}
              noteId={props.noteId}
              effectiveDate={props.effectiveDate}
              effectiveDateTime={props.effectiveDateTime}
              fileUrls={props.fileUrls}
              clientId={props.clientId}
              closemodal={closeEditModal}
            />
          ) : props.noteType === "aftercareNote" ? (
            <EditAftercareNote
              note={props.noteContent}
              noteId={props.noteId}
              effectiveDate={props.effectiveDate}
              effectiveDateTime={props.effectiveDateTime}
              fileUrls={props.fileUrls}
              clientId={props.clientId}
              closemodal={closeEditModal}
            />
          ) : props.noteType === "supportStaffNote" ? (
            <EditSupportStaffNote
              note={props.noteContent}
              noteId={props.noteId}
              effectiveDate={props.effectiveDate}
              effectiveDateTime={props.effectiveDateTime}
              fileUrls={props.fileUrls}
              clientId={props.clientId}
              closemodal={closeEditModal}
            />
          ) : props.noteType === "psychoEdNote" ? (
            <EditPsychoEdNote
              note={props.noteContent}
              noteId={props.noteId}
              effectiveDate={props.effectiveDate}
              effectiveDateTime={props.effectiveDateTime}
              subject={props.subject}
              fileUrls={props.fileUrls}
              clientId={props.clientId}
              closemodal={closeEditModal}
            />
          ) : (
            <EditQuickNote
              note={props.noteContent}
              noteId={props.noteId}
              typeOfNote={props.noteType}
              effectiveDate={props.effectiveDate}
              closemodal={closeEditModal}
            />
          )}
        </Box>
      </Modal>

      <Modal open={showDeleteModal} onClose={closeDeleteModal}>
        <Box sx={styleDeleteModal}>
          <DeleteNote
            note={props.noteContent}
            noteId={props.noteId}
            typeOfNote={props.noteType}
            effectiveDate={props.effectiveDate}
            closemodal={closeDeleteModal}
          />
        </Box>
      </Modal>

      <Modal open={showViewModal} onClose={closeViewModal}>
        <Box sx={styleLive}>
          <ViewNote
            note={props.noteContent}
            noteId={props.noteId}
            typeOfNote={props.noteType}
            effectiveDate={props.effectiveDate}
            closemodal={closeViewModal}
            fileUrls={props.fileUrls}
          />
        </Box>
      </Modal>
      <div
        className="note-container"
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          justifyContent: "flex-start",
          alignContent: "flex-start",
          alignItems: "flex-start",
          paddingLeft: "20px",
          height: "auto",
          paddingBottom: "10px",
          paddingRight: "10px",
          width: "100%",
        }}
      >
        <div
          className="note-container-block-1"
          style={{
            width: "auto",
            gap: "10px",
            height: "auto",
            flexDirection: "row",
          }}
        >
          <DateAndTimeChip date={props.noteDate} />
          <DateAndTimeChip date={props.noteTime} />
          <TypeNoteChip noteType={props.noteType} />
        </div>

        <div className="note-container-block-3" style={{ width: "100%" }}>
          <div className="note-container-line-1">
            <div
              className="note-container-line1-block1 centre-block"
              onClick={handleNavigate}
              style={{ cursor: "pointer" }}
            >
              {props.subject ? (
                <div
                  style={{
                    fontWeight: 700,
                    color: "#1565c0",
                    marginBottom: 4,
                    maxWidth: 200,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {props.subject}
                </div>
              ) : (
                <SmallClientChip
                  firstName={props.clientFirstName}
                  lastName={props.clientLastName}
                  avatar="1"
                  clientPic={props.clientPic}
                />
              )}
            </div>
            <div className="note-container-line1-block1bis left-block">
              <div className="title-cell-container">Done by:</div>
              <div className="content-cell-container">{props.doneBy}</div>
            </div>
            <div className="note-container-line1-block2 left-block">
              <div className="title-cell-container">Timestamp:</div>
              <div className="content-cell-container">
                {props.timeStamp}
              </div>{" "}
              <span
                style={{ fontSize: "10px", textAlign: "left", width: "100%" }}
              >
                {props.lastModification &&
                  `(Last modification: ${props.lastModification})`}
              </span>
            </div>
            <div className="note-container-line1-block2 centre-block2">
              <div className="sub-block-2">
                <EditButton handleOpen={openEditModal} />
                <DeleteButton handleOpen={openDeleteModal} />
              </div>
            </div>
          </div>
          <div
            className="note-container-line-2"
            style={{ whiteSpace: "pre-wrap" }}
          >
            {props.noteContent}
          </div>
          {props.fileUrls?.length ? (
            <div className="note-container-line-2">
              <strong>Files: </strong>
              {props.fileUrls.map((file, index) => (
                <React.Fragment key={`${file.url || file.name}-${index}`}>
                  {index > 0 && ", "}
                  <a href={file.url} target="_blank" rel="noreferrer">
                    {file.name || "File"}
                  </a>
                </React.Fragment>
              ))}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default NotesContainerWithSubject;
